import axios from 'axios';
import { criptObjectOnLocalStorage, decriptoLocalStorage } from '../../modulos/cripotografia/criptoStorage';
import interceptorRequestAxios from '../interceptors/request-axios';
import { interceptorResponseAxios, interceptorResponseErrorAxios } from '../interceptors/response-axios';
import { retornoHashValor } from '../../modulos/cripotografia/hash';

const url = retornoHashValor(process.env.REACT_APP_7);
const CLIENT = process.env.REACT_APP_CLIENT_ID_PASS;

const token = localStorage.getItem('token');

const apiZelo = axios.create({
    baseURL: url,
    headers: {
        'Content-Type': 'application/json',
        'x-auth-token': `${token}`
    }
});

if (process.env.REACT_APP_ENV === 'prod') {
    apiZelo.interceptors.request.use(interceptorRequestAxios);
    apiZelo.interceptors.response.use(interceptorResponseAxios, interceptorResponseErrorAxios);
}

apiZelo.interceptors.request.use(
    async config => {
        try{
            let ExpirePass = decriptoLocalStorage('expirePass');

            ExpirePass = ExpirePass === null ? undefined : ExpirePass;

            if (ExpirePass) {
                const now = new Date();
                const past = new Date(ExpirePass);
                const diff = Math.abs(now.getTime() - past.getTime());
                const days = Math.ceil(diff / (1000 * 60 * 60));
                const min = Math.ceil(diff / (1000 * 60));

                if (days > 1) {
                    criptObjectOnLocalStorage('expirePass', new Date());
                } else if (min > 50) {
                    criptObjectOnLocalStorage('expirePass', new Date());
                }
            } else {
                criptObjectOnLocalStorage('expirePass', new Date());
            }

            const client_id = CLIENT;
            const access_token = localStorage.getItem('access_token_pass');

            config.headers['client_id'] =  client_id;
            config.headers['access_token'] =  access_token;

            return config;
        } catch(error){
            console.log(error);
        }
    });

export default apiZelo;
